var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21767_204622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8432 0.566884C2.85401 0.545043 2.87071 0.526659 2.89141 0.513805C2.91211 0.500952 2.936 0.494141 2.96037 0.494141C2.98474 0.494141 3.00862 0.500952 3.02933 0.513805C3.05003 0.526659 3.06673 0.545043 3.07754 0.566884L3.64736 1.72108C3.6849 1.79705 3.74031 1.86277 3.80884 1.91261C3.87737 1.96245 3.95697 1.99492 4.04081 2.00722L5.31514 2.19371C5.33928 2.19721 5.36197 2.2074 5.38063 2.22312C5.39928 2.23884 5.41317 2.25946 5.42072 2.28266C5.42826 2.30587 5.42917 2.33072 5.42332 2.35441C5.41748 2.37809 5.40513 2.39967 5.38766 2.41671L4.46608 3.31411C4.4053 3.37334 4.35983 3.44645 4.33357 3.52715C4.30732 3.60785 4.30107 3.69372 4.31536 3.77737L4.53293 5.04529C4.53719 5.06942 4.53458 5.09427 4.5254 5.11699C4.51622 5.13971 4.50084 5.1594 4.48101 5.1738C4.46118 5.18821 4.4377 5.19674 4.41326 5.19845C4.38881 5.20015 4.36437 5.19494 4.34274 5.18342L3.20359 4.58449C3.12853 4.54508 3.04502 4.52449 2.96024 4.52449C2.87547 4.52449 2.79196 4.54508 2.7169 4.58449L1.578 5.18342C1.55637 5.19487 1.53197 5.20002 1.50756 5.19829C1.48315 5.19655 1.45972 5.188 1.43993 5.17361C1.42014 5.15922 1.40479 5.13956 1.39562 5.11688C1.38645 5.09419 1.38383 5.06939 1.38805 5.04529L1.60538 3.77762C1.61973 3.69393 1.61351 3.608 1.58726 3.52725C1.561 3.4465 1.51549 3.37335 1.45466 3.31411L0.533076 2.41695C0.515462 2.39994 0.50298 2.37832 0.497052 2.35456C0.491124 2.3308 0.491989 2.30585 0.499548 2.28256C0.507106 2.25927 0.521055 2.23857 0.539805 2.22282C0.558554 2.20706 0.581351 2.19689 0.605599 2.19346L1.87968 2.00722C1.96361 1.99501 2.04332 1.96259 2.11195 1.91274C2.18057 1.8629 2.23605 1.79712 2.27362 1.72108L2.8432 0.566884Z",
    fill: "#FDC700",
    stroke: "#FDC700",
    strokeWidth: 0.493352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21767_204622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.92022,
    height: 5.92022,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c9c5ff37fb7eaad1ee035f00ddf3ccae.svg";
export { ForwardRef as ReactComponent };